import { render, staticRenderFns } from "./AuthoritiesForm.vue?vue&type=template&id=604da77a&scoped=true"
import script from "./AuthoritiesForm.vue?vue&type=script&lang=js"
export * from "./AuthoritiesForm.vue?vue&type=script&lang=js"
import style0 from "./AuthoritiesForm.vue?vue&type=style&index=0&id=604da77a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "604da77a",
  null
  
)

export default component.exports